import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import emitter from "../Game/Events/EventManager";
import { LEFT_EXIT, RIGHT_EXIT, LEFT_GO, RIGHT_GO } from "../Game/Events/Events";
import { CHOOSE_TC, CHOOSE_SC, CHOOSE_EN, NEXT_PROGRESS, QUIT_GAME } from "../Game/Events/Events";
import store from "../store/store.jsx";
import { dispatchChangeScene, dispatchChangeLang } from "../Game/reducers/sceneReducer";

export default function Scene3Overlay() {
  const currentQuestion = useSelector(state => state.currentScene.currentQuestion);
  const leftCVEnabled = useSelector(state => state.currentScene.leftEnabled);
  const rightCVEnabled = useSelector(state => state.currentScene.rightEnabled);
  const lang = useSelector(state => state.currentScene.currentLang);

  return (
    <div className="hidden">
      <CVs currentQuestion={currentQuestion} leftCVEnabled={leftCVEnabled} rightCVEnabled={rightCVEnabled} lang={lang} />
    </div>
  );
}

function CVs(props) {
  const currentQuestion = props.currentQuestion;
  const leftCVEnabled = props.leftCVEnabled;
  const rightCVEnabled = props.rightCVEnabled;
  const lang = props.lang || "TC";

  const initalTexts = {
    leftCV: "",
    righCV: "",
    leftExit: " enter",
    rightExit: " enter",
    leftGoInterview: " enter",
    rightGoInterview: " enter"
  };

  let texts = initalTexts;

  if (currentQuestion) {
    texts = gameText(lang);
  }

  function gameText(langCode) {
    if (langCode == "TC") {
      return {
        question: currentQuestion.question == "intern" ? "遊戲開始，我需要一位工作實習學員" : "遊戲開始，我需要一位工作經驗學員",
        leftCV: "左邊應徵者履歷",
        rightCV: "右邊應徵者履歷",
        leftExit: "左邊應徵者離開，按 enter",
        rightExit: "右邊應徵者離開，按 enter",
        leftGoInterview: "左邊應徵者嘗試面試，按 enter",
        rightGoInterview: "右邊應徵者嘗試面試，按 enter",
        quitGame: "離開遊戲"
      };
    }

    if (langCode == "EN") {
      return {
        question: currentQuestion.question == "intern" ? "Game start, I need a student intern" : "Game start, I need a work experience student",
        leftCV: "left interviewer's CV",
        rightCV: "right interviewer's CV",
        leftExit: "left interviewer exits, press enter",
        rightExit: "right interviewer exits, press enter",
        leftGoInterview: "left interviewer tries to interview, press enter",
        rightGoInterview: "right interviewer tries to interview, press enter",
        quitGame: "quit game"
      };
    }
    if (langCode == "SC") {
      return {
        question: currentQuestion.question == "intern" ? "游戏开始，我需要一位工作实习学员" : "游戏开始，我需要一位工作经验学员",
        leftCV: "左边应徵者履历",
        rightCV: "右边应徵者履历",
        leftExit: "左边应徵者离开，按 enter",
        rightExit: "右边应徵者离开，按 enter",
        leftGoInterview: "左边应徵者尝试面试，按 enter",
        rightGoInterview: "右边应徵者尝试面试，按 enter",
        quitGame: "离开游戏"
      };
    }
  }

  return !currentQuestion ? null : (
    <div>
      <div tabIndex="1">{texts.question}</div>

      <div
        tabIndex="2"
        onKeyDown={e => {
          if (e.keyCode == 13) {
            emitter.emit(QUIT_GAME);
          }
        }}
      >
        {texts.quitGame}
      </div>

      {/*========== LEFT INTERVIEWER ==========*/}
      {!leftCVEnabled ? null : (
        <Fragment>
          <div tabIndex="3">{texts.leftCV + ": " + CVText(currentQuestion.left_description, lang)}</div>
          <div
            tabIndex="4"
            onKeyDown={e => {
              if (e.keyCode == 13) {
                emitter.emit(LEFT_EXIT);
              }
            }}
          >
            {texts.leftExit}
          </div>
          <div
            tabIndex="5"
            onKeyDown={e => {
              if (e.keyCode == 13) {
                emitter.emit(LEFT_EXIT);
              }
            }}
          >
            {texts.leftGoInterview}
          </div>
        </Fragment>
      )}

      {/*========== LEFT INTERVIEWER ==========*/}

      {/*========== RIGHT INTERVIEWER ==========*/}
      {!rightCVEnabled ? null : (
        <Fragment>
          <div tabIndex="6">{texts.rightCV + ": " + CVText(currentQuestion.right_description, lang)}</div>

          <div
            tabIndex="7"
            onKeyDown={e => {
              if (e.keyCode == 13) {
                emitter.emit(RIGHT_EXIT);
              }
            }}
          >
            {texts.rightExit}
          </div>
          <div
            tabIndex="8"
            onKeyDown={e => {
              if (e.keyCode == 13) {
                emitter.emit(RIGHT_GO);
              }
            }}
          >
            {texts.rightGoInterview}
          </div>
        </Fragment>
      )}

      {/*========== RIGHT INTERVIEWER ==========*/}
    </div>
  );
}

function CVText(description, lang) {
  let internText;
  let ageText;
  if (lang == "TC") {
    internText = "實習期：";
    ageText = "年齡：";
  }

  if (lang == "SC") {
    internText = "实习期：";
    ageText = "年龄：";
  }

  if (lang == "EN") {
    internText = "Duration of internship: ";
    ageText = "Age: ";
  }

  if (description.internship != null) {
    return internText + description.internship + description.more;
  }

  if (description.age != null) {
    return ageText + description.age;
  }

  if (description.organization != null) {
    return description.organization + "，" + description.authorized;
  }

  if (description.course != null) {
    return description.course;
  }

  if (description.relatedOrNot != null) {
    return description.relatedOrNot + "，" + description.related;
  }

  if (description.contract != null) {
    return description.contract;
  }

  if (description.agreement != null) {
    return description.agreement;
  }
}
